import { typography } from "@shared/common/Themes/typography.ts";

export const getTextWidth = (
  text: string | undefined,
  fontSize: number,
  fontWeight: number
) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (context === null || !text) return 0;

  context.font =
    `${fontWeight} ${fontSize}px ${typography.fontFamily}` ||
    getComputedStyle(document.body).font;

  return context.measureText(text).width;
};
